export const IndonesianCities = [
  {
    city_name: "Aceh Barat"
  },
  {
    city_name: "Aceh Barat Daya"
  },
  {
    city_name: "Aceh Besar"
  },
  {
    city_name: "Aceh Jaya"
  },
  {
    city_name: "Aceh Selatan"
  },
  {
    city_name: "Aceh Singkil"
  },
  {
    city_name: "Aceh Tamiang"
  },
  {
    city_name: "Aceh Tengah"
  },
  {
    city_name: "Aceh Tenggara"
  },
  {
    city_name: "Aceh Timur"
  },
  {
    city_name: "Aceh Utara"
  },
  {
    city_name: "Agam"
  },
  {
    city_name: "Alor"
  },
  {
    city_name: "Ambon"
  },
  {
    city_name: "Asahan"
  },
  {
    city_name: "Asmat"
  },
  {
    city_name: "Badung"
  },
  {
    city_name: "Balangan"
  },
  {
    city_name: "Balikpapan"
  },
  {
    city_name: "Banda Aceh"
  },
  {
    city_name: "Bandar Lampung"
  },
  {
    city_name: "Bandung"
  },
  {
    city_name: "Bandung Barat"
  },
  {
    city_name: "Banggai"
  },
  {
    city_name: "Banggai Kepulauan"
  },
  {
    city_name: "Bangka"
  },
  {
    city_name: "Bangka Barat"
  },
  {
    city_name: "Bangka Selatan"
  },
  {
    city_name: "Bangka Tengah"
  },
  {
    city_name: "Bangkalan"
  },
  {
    city_name: "Bangli"
  },
  {
    city_name: "Banjar"
  },
  {
    city_name: "Banjar Baru"
  },
  {
    city_name: "Banjarmasin"
  },
  {
    city_name: "Banjarnegara"
  },
  {
    city_name: "Bantaeng"
  },
  {
    city_name: "Bantul"
  },
  {
    city_name: "Banyu Asin"
  },
  {
    city_name: "Banyumas"
  },
  {
    city_name: "Banyuwangi"
  },
  {
    city_name: "Barito Kuala"
  },
  {
    city_name: "Barito Selatan"
  },
  {
    city_name: "Barito Timur"
  },
  {
    city_name: "Barito Utara"
  },
  {
    city_name: "Barru"
  },
  {
    city_name: "Baru"
  },
  {
    city_name: "Batam"
  },
  {
    city_name: "Batang"
  },
  {
    city_name: "Batang Hari"
  },
  {
    city_name: "Batu"
  },
  {
    city_name: "Batu Bara"
  },
  {
    city_name: "Baubau"
  },
  {
    city_name: "Bekasi"
  },
  {
    city_name: "Belitung"
  },
  {
    city_name: "Belitung Timur"
  },
  {
    city_name: "Belu"
  },
  {
    city_name: "Bener Meriah"
  },
  {
    city_name: "Bengkalis"
  },
  {
    city_name: "Bengkayang"
  },
  {
    city_name: "Bengkulu"
  },
  {
    city_name: "Bengkulu Selatan"
  },
  {
    city_name: "Bengkulu Tengah"
  },
  {
    city_name: "Bengkulu Utara"
  },
  {
    city_name: "Berau"
  },
  {
    city_name: "Biak Numfor"
  },
  {
    city_name: "Bima"
  },
  {
    city_name: "Binjai"
  },
  {
    city_name: "Bintan"
  },
  {
    city_name: "Bireuen"
  },
  {
    city_name: "Bitung"
  },
  {
    city_name: "Blitar"
  },
  {
    city_name: "Blora"
  },
  {
    city_name: "Boalemo"
  },
  {
    city_name: "Bogor"
  },
  {
    city_name: "Bojonegoro"
  },
  {
    city_name: "Bolaang Mongondow"
  },
  {
    city_name: "Bolaang Mongondow Selatan"
  },
  {
    city_name: "Bolaang Mongondow Timur"
  },
  {
    city_name: "Bolaang Mongondow Utara"
  },
  {
    city_name: "Bombana"
  },
  {
    city_name: "Bondowoso"
  },
  {
    city_name: "Bone"
  },
  {
    city_name: "Bone Bolango"
  },
  {
    city_name: "Bontang"
  },
  {
    city_name: "Boven Digoel"
  },
  {
    city_name: "Boyolali"
  },
  {
    city_name: "Brebes"
  },
  {
    city_name: "Bukittinggi"
  },
  {
    city_name: "Buleleng"
  },
  {
    city_name: "Bulukumba"
  },
  {
    city_name: "Bulungan"
  },
  {
    city_name: "Bungo"
  },
  {
    city_name: "Buol"
  },
  {
    city_name: "Buru"
  },
  {
    city_name: "Buru Selatan"
  },
  {
    city_name: "Buton"
  },
  {
    city_name: "Buton Utara"
  },
  {
    city_name: "Ciamis"
  },
  {
    city_name: "Cianjur"
  },
  {
    city_name: "Cilacap"
  },
  {
    city_name: "Cilegon"
  },
  {
    city_name: "Cimahi"
  },
  {
    city_name: "Cirebon"
  },
  {
    city_name: "Dairi"
  },
  {
    city_name: "Deiyai"
  },
  {
    city_name: "Deli Serdang"
  },
  {
    city_name: "Demak"
  },
  {
    city_name: "Denpasar"
  },
  {
    city_name: "Depok"
  },
  {
    city_name: "Dharmasraya"
  },
  {
    city_name: "Dogiyai"
  },
  {
    city_name: "Dompu"
  },
  {
    city_name: "Donggala"
  },
  {
    city_name: "Dumai"
  },
  {
    city_name: "Empat Lawang"
  },
  {
    city_name: "Ende"
  },
  {
    city_name: "Enrekang"
  },
  {
    city_name: "Fakfak"
  },
  {
    city_name: "Flores Timur"
  },
  {
    city_name: "Garut"
  },
  {
    city_name: "Gayo Lues"
  },
  {
    city_name: "Gianyar"
  },
  {
    city_name: "Gorontalo"
  },
  {
    city_name: "Gorontalo Utara"
  },
  {
    city_name: "Gowa"
  },
  {
    city_name: "Gresik"
  },
  {
    city_name: "Grobogan"
  },
  {
    city_name: "Gunung Kidul"
  },
  {
    city_name: "Gunung Mas"
  },
  {
    city_name: "Gunungsitoli"
  },
  {
    city_name: "Halmahera Barat"
  },
  {
    city_name: "Halmahera Selatan"
  },
  {
    city_name: "Halmahera Tengah"
  },
  {
    city_name: "Halmahera Timur"
  },
  {
    city_name: "Halmahera Utara"
  },
  {
    city_name: "Hulu Sungai Selatan"
  },
  {
    city_name: "Hulu Sungai Tengah"
  },
  {
    city_name: "Hulu Sungai Utara"
  },
  {
    city_name: "Humbang Hasundutan"
  },
  {
    city_name: "Indragiri Hilir"
  },
  {
    city_name: "Indragiri Hulu"
  },
  {
    city_name: "Indramayu"
  },
  {
    city_name: "Intan Jaya"
  },
  {
    city_name: "Jakarta Barat"
  },
  {
    city_name: "Jakarta Pusat"
  },
  {
    city_name: "Jakarta Selatan"
  },
  {
    city_name: "Jakarta Timur"
  },
  {
    city_name: "Jakarta Utara"
  },
  {
    city_name: "Jambi"
  },
  {
    city_name: "Jayapura"
  },
  {
    city_name: "Jayapura "
  },
  {
    city_name: "Jayawijaya"
  },
  {
    city_name: "Jember"
  },
  {
    city_name: "Jembrana"
  },
  {
    city_name: "Jeneponto"
  },
  {
    city_name: "Jepara"
  },
  {
    city_name: "Jombang"
  },
  {
    city_name: "Kaimana"
  },
  {
    city_name: "Kampar"
  },
  {
    city_name: "Kapuas"
  },
  {
    city_name: "Kapuas Hulu"
  },
  {
    city_name: "Karang Asem"
  },
  {
    city_name: "Karanganyar"
  },
  {
    city_name: "Karawang"
  },
  {
    city_name: "Karimun"
  },
  {
    city_name: "Karo"
  },
  {
    city_name: "Katingan"
  },
  {
    city_name: "Kaur"
  },
  {
    city_name: "Kayong Utara"
  },
  {
    city_name: "Kebumen"
  },
  {
    city_name: "Kediri"
  },
  {
    city_name: "Keerom"
  },
  {
    city_name: "Kendal"
  },
  {
    city_name: "Kendari"
  },
  {
    city_name: "Kepahiang"
  },
  {
    city_name: "Kepulauan Anambas"
  },
  {
    city_name: "Kepulauan Aru"
  },
  {
    city_name: "Kepulauan Mentawai"
  },
  {
    city_name: "Kepulauan Meranti"
  },
  {
    city_name: "Kepulauan Sangihe"
  },
  {
    city_name: "Kepulauan Selayar"
  },
  {
    city_name: "Kepulauan Seribu"
  },
  {
    city_name: "Kepulauan Sula"
  },
  {
    city_name: "Kepulauan Talaud"
  },
  {
    city_name: "Kepulauan Yapen"
  },
  {
    city_name: "Kerinci"
  },
  {
    city_name: "Ketapang"
  },
  {
    city_name: "Klaten"
  },
  {
    city_name: "Klungkung"
  },
  {
    city_name: "Kolaka"
  },
  {
    city_name: "Kolaka Utara"
  },
  {
    city_name: "Konawe"
  },
  {
    city_name: "Konawe Selatan"
  },
  {
    city_name: "Konawe Utara"
  },
  {
    city_name: "Kotamobagu"
  },
  {
    city_name: "Kotawaringin Barat"
  },
  {
    city_name: "Kotawaringin Timur"
  },
  {
    city_name: "Kuantan Singingi"
  },
  {
    city_name: "Kubu Raya"
  },
  {
    city_name: "Kudus"
  },
  {
    city_name: "Kulon Progo"
  },
  {
    city_name: "Kuningan"
  },
  {
    city_name: "Kupang"
  },
  {
    city_name: "Kutai Barat"
  },
  {
    city_name: "Kutai Kartanegara"
  },
  {
    city_name: "Kutai Timur"
  },
  {
    city_name: "Labuhan Batu"
  },
  {
    city_name: "Labuhan Batu Selatan"
  },
  {
    city_name: "Labuhan Batu Utara"
  },
  {
    city_name: "Lahat"
  },
  {
    city_name: "Lamandau"
  },
  {
    city_name: "Lamongan"
  },
  {
    city_name: "Lampung Barat"
  },
  {
    city_name: "Lampung Selatan"
  },
  {
    city_name: "Lampung Tengah"
  },
  {
    city_name: "Lampung Timur"
  },
  {
    city_name: "Lampung Utara"
  },
  {
    city_name: "Landak"
  },
  {
    city_name: "Langkat"
  },
  {
    city_name: "Langsa"
  },
  {
    city_name: "Lanny Jaya"
  },
  {
    city_name: "Lebak"
  },
  {
    city_name: "Lebong"
  },
  {
    city_name: "Lembata"
  },
  {
    city_name: "Lhokseumawe"
  },
  {
    city_name: "Lima Puluh Kota"
  },
  {
    city_name: "Lingga"
  },
  {
    city_name: "Lombok Barat"
  },
  {
    city_name: "Lombok Tengah"
  },
  {
    city_name: "Lombok Timur"
  },
  {
    city_name: "Lombok Utara"
  },
  {
    city_name: "Lubuklinggau"
  },
  {
    city_name: "Lumajang"
  },
  {
    city_name: "Luwu"
  },
  {
    city_name: "Luwu Timur"
  },
  {
    city_name: "Luwu Utara"
  },
  {
    city_name: "Madiun"
  },
  {
    city_name: "Magelang"
  },
  {
    city_name: "Magetan"
  },
  {
    city_name: "Majalengka"
  },
  {
    city_name: "Majene"
  },
  {
    city_name: "Makassar"
  },
  {
    city_name: "Malang"
  },
  {
    city_name: "Malinau"
  },
  {
    city_name: "Maluku Barat Daya"
  },
  {
    city_name: "Maluku Tengah"
  },
  {
    city_name: "Maluku Tenggara"
  },
  {
    city_name: "Maluku Tenggara Barat"
  },
  {
    city_name: "Mamasa"
  },
  {
    city_name: "Mamberamo Raya"
  },
  {
    city_name: "Mamberamo Tengah"
  },
  {
    city_name: "Mamuju"
  },
  {
    city_name: "Mamuju Utara"
  },
  {
    city_name: "Manado"
  },
  {
    city_name: "Mandailing Natal"
  },
  {
    city_name: "Manggarai"
  },
  {
    city_name: "Manggarai Barat"
  },
  {
    city_name: "Manggarai Timur"
  },
  {
    city_name: "Manokwari"
  },
  {
    city_name: "Mappi"
  },
  {
    city_name: "Maros"
  },
  {
    city_name: "Mataram"
  },
  {
    city_name: "Maybrat"
  },
  {
    city_name: "Medan"
  },
  {
    city_name: "Melawi"
  },
  {
    city_name: "Merangin"
  },
  {
    city_name: "Merauke"
  },
  {
    city_name: "Mesuji"
  },
  {
    city_name: "Metro"
  },
  {
    city_name: "Mimika"
  },
  {
    city_name: "Minahasa"
  },
  {
    city_name: "Minahasa Selatan"
  },
  {
    city_name: "Minahasa Tenggara"
  },
  {
    city_name: "Minahasa Utara"
  },
  {
    city_name: "Mojokerto"
  },
  {
    city_name: "Morowali"
  },
  {
    city_name: "Muara Enim"
  },
  {
    city_name: "Muaro Jambi"
  },
  {
    city_name: "Mukomuko"
  },
  {
    city_name: "Muna"
  },
  {
    city_name: "Murung Raya"
  },
  {
    city_name: "Musi Banyuasin"
  },
  {
    city_name: "Musi Rawas"
  },
  {
    city_name: "Nabire"
  },
  {
    city_name: "Nagan Raya"
  },
  {
    city_name: "Nagekeo"
  },
  {
    city_name: "Natuna"
  },
  {
    city_name: "Nduga"
  },
  {
    city_name: "Ngada"
  },
  {
    city_name: "Nganjuk"
  },
  {
    city_name: "Ngawi"
  },
  {
    city_name: "Nias"
  },
  {
    city_name: "Nias Barat"
  },
  {
    city_name: "Nias Selatan"
  },
  {
    city_name: "Nias Utara"
  },
  {
    city_name: "Nunukan"
  },
  {
    city_name: "Ogan Ilir"
  },
  {
    city_name: "Ogan Komering Ilir"
  },
  {
    city_name: "Ogan Komering Ulu"
  },
  {
    city_name: "Ogan Komering Ulu Selatan"
  },
  {
    city_name: "Ogan Komering Ulu Timur"
  },
  {
    city_name: "Pacitan"
  },
  {
    city_name: "Padang"
  },
  {
    city_name: "Padang Lawas"
  },
  {
    city_name: "Padang Lawas Utara"
  },
  {
    city_name: "Padang Panjang"
  },
  {
    city_name: "Padang Pariaman"
  },
  {
    city_name: "Padangsidimpuan"
  },
  {
    city_name: "Pagar Alam"
  },
  {
    city_name: "Pakpak Bharat"
  },
  {
    city_name: "Palangka Raya"
  },
  {
    city_name: "Palembang"
  },
  {
    city_name: "Palopo"
  },
  {
    city_name: "Palu"
  },
  {
    city_name: "Pamekasan"
  },
  {
    city_name: "Pandeglang"
  },
  {
    city_name: "Pangandaran"
  },
  {
    city_name: "Pangkajene Dan Kepulauan"
  },
  {
    city_name: "Pangkal Pinang"
  },
  {
    city_name: "Paniai"
  },
  {
    city_name: "Parepare"
  },
  {
    city_name: "Pariaman"
  },
  {
    city_name: "Parigi Moutong"
  },
  {
    city_name: "Pasaman"
  },
  {
    city_name: "Pasaman Barat"
  },
  {
    city_name: "Paser"
  },
  {
    city_name: "Pasuruan"
  },
  {
    city_name: "Pati"
  },
  {
    city_name: "Payakumbuh"
  },
  {
    city_name: "Pegunungan Bintang"
  },
  {
    city_name: "Pekalongan"
  },
  {
    city_name: "Pekanbaru"
  },
  {
    city_name: "Pelalawan"
  },
  {
    city_name: "Pemalang"
  },
  {
    city_name: "Pematang Siantar"
  },
  {
    city_name: "Penajam Paser Utara"
  },
  {
    city_name: "Pesawaran"
  },
  {
    city_name: "Pesisir Barat"
  },
  {
    city_name: "Pesisir Selatan"
  },
  {
    city_name: "Pidie"
  },
  {
    city_name: "Pidie Jaya"
  },
  {
    city_name: "Pinrang"
  },
  {
    city_name: "Pohuwato"
  },
  {
    city_name: "Polewali Mandar"
  },
  {
    city_name: "Ponorogo"
  },
  {
    city_name: "Pontianak"
  },
  {
    city_name: "Poso"
  },
  {
    city_name: "Prabumulih"
  },
  {
    city_name: "Pringsewu"
  },
  {
    city_name: "Probolinggo"
  },
  {
    city_name: "Pulang Pisau"
  },
  {
    city_name: "Pulau Morotai"
  },
  {
    city_name: "Puncak"
  },
  {
    city_name: "Puncak Jaya"
  },
  {
    city_name: "Purbalingga"
  },
  {
    city_name: "Purwakarta"
  },
  {
    city_name: "Purworejo"
  },
  {
    city_name: "Raja Ampat"
  },
  {
    city_name: "Rejang Lebong"
  },
  {
    city_name: "Rembang"
  },
  {
    city_name: "Rokan Hilir"
  },
  {
    city_name: "Rokan Hulu"
  },
  {
    city_name: "Rote Ndao"
  },
  {
    city_name: "Sabang"
  },
  {
    city_name: "Sabu Raijua"
  },
  {
    city_name: "Salatiga"
  },
  {
    city_name: "Samarinda"
  },
  {
    city_name: "Sambas"
  },
  {
    city_name: "Samosir"
  },
  {
    city_name: "Sampang"
  },
  {
    city_name: "Sanggau"
  },
  {
    city_name: "Sarmi"
  },
  {
    city_name: "Sarolangun"
  },
  {
    city_name: "Sawah Lunto"
  },
  {
    city_name: "Sekadau"
  },
  {
    city_name: "Seluma"
  },
  {
    city_name: "Semarang"
  },
  {
    city_name: "Seram Bagian Barat"
  },
  {
    city_name: "Seram Bagian Timur"
  },
  {
    city_name: "Serang"
  },
  {
    city_name: "Serdang Bedagai"
  },
  {
    city_name: "Seruyan"
  },
  {
    city_name: "Siak"
  },
  {
    city_name: "Siau Tagulandang Biaro"
  },
  {
    city_name: "Sibolga"
  },
  {
    city_name: "Sidenreng Rappang"
  },
  {
    city_name: "Sidoarjo"
  },
  {
    city_name: "Sigi"
  },
  {
    city_name: "Sijunjung"
  },
  {
    city_name: "Sikka"
  },
  {
    city_name: "Simalungun"
  },
  {
    city_name: "Simeulue"
  },
  {
    city_name: "Singkawang"
  },
  {
    city_name: "Sinjai"
  },
  {
    city_name: "Sintang"
  },
  {
    city_name: "Situbondo"
  },
  {
    city_name: "Sleman"
  },
  {
    city_name: "Solok"
  },
  {
    city_name: "Solok Selatan"
  },
  {
    city_name: "Soppeng"
  },
  {
    city_name: "Sorong"
  },
  {
    city_name: "Sorong Selatan"
  },
  {
    city_name: "Sragen"
  },
  {
    city_name: "Subang"
  },
  {
    city_name: "Subulussalam"
  },
  {
    city_name: "Sukabumi"
  },
  {
    city_name: "Sukamara"
  },
  {
    city_name: "Sukoharjo"
  },
  {
    city_name: "Sumba Barat"
  },
  {
    city_name: "Sumba Barat Daya"
  },
  {
    city_name: "Sumba Tengah"
  },
  {
    city_name: "Sumba Timur"
  },
  {
    city_name: "Sumbawa"
  },
  {
    city_name: "Sumbawa Barat"
  },
  {
    city_name: "Sumedang"
  },
  {
    city_name: "Sumenep"
  },
  {
    city_name: "Sungai Penuh"
  },
  {
    city_name: "Supiori"
  },
  {
    city_name: "Surabaya"
  },
  {
    city_name: "Surakarta"
  },
  {
    city_name: "Tabalong"
  },
  {
    city_name: "Tabanan"
  },
  {
    city_name: "Takalar"
  },
  {
    city_name: "Tambrauw"
  },
  {
    city_name: "Tana Tidung"
  },
  {
    city_name: "Tana Toraja"
  },
  {
    city_name: "Tanah Bumbu"
  },
  {
    city_name: "Tanah Datar"
  },
  {
    city_name: "Tanah Laut"
  },
  {
    city_name: "Tangerang"
  },
  {
    city_name: "Tangerang Selatan"
  },
  {
    city_name: "Tanggamus"
  },
  {
    city_name: "Tanjung Balai"
  },
  {
    city_name: "Tanjung Jabung Barat"
  },
  {
    city_name: "Tanjung Jabung Timur"
  },
  {
    city_name: "Tanjung Pinang"
  },
  {
    city_name: "Tapanuli Selatan"
  },
  {
    city_name: "Tapanuli Tengah"
  },
  {
    city_name: "Tapanuli Utara"
  },
  {
    city_name: "Tapin"
  },
  {
    city_name: "Tarakan"
  },
  {
    city_name: "Tasikmalaya"
  },
  {
    city_name: "Tebing Tinggi"
  },
  {
    city_name: "Tebo"
  },
  {
    city_name: "Tegal"
  },
  {
    city_name: "Teluk Bintuni"
  },
  {
    city_name: "Teluk Wondama"
  },
  {
    city_name: "Temanggung"
  },
  {
    city_name: "Ternate"
  },
  {
    city_name: "Tidore Kepulauan"
  },
  {
    city_name: "Timor Tengah Selatan"
  },
  {
    city_name: "Timor Tengah Utara"
  },
  {
    city_name: "Toba Samosir"
  },
  {
    city_name: "Tojo Una-una"
  },
  {
    city_name: "Toli-toli"
  },
  {
    city_name: "Tolikara"
  },
  {
    city_name: "Tomohon"
  },
  {
    city_name: "Toraja Utara"
  },
  {
    city_name: "Trenggalek"
  },
  {
    city_name: "Tual"
  },
  {
    city_name: "Tuban"
  },
  {
    city_name: "Tulang Bawang Barat"
  },
  {
    city_name: "Tulangbawang"
  },
  {
    city_name: "Tulungagung"
  },
  {
    city_name: "Wajo"
  },
  {
    city_name: "Wakatobi"
  },
  {
    city_name: "Waropen"
  },
  {
    city_name: "Way Kanan"
  },
  {
    city_name: "Wonogiri"
  },
  {
    city_name: "Wonosobo"
  },
  {
    city_name: "Yahukimo"
  },
  {
    city_name: "Yalimo"
  },
  {
    city_name: "Yogyakarta"
  }
];
